import validate from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/node_modules/.pnpm/nuxt@3.10.3_@parcel+watcher_a67026a031e3754dda11d6a6568d367d/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/node_modules/.pnpm/nuxt@3.10.3_@parcel+watcher_a67026a031e3754dda11d6a6568d367d/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "0-auth": () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/middleware/0.auth.ts")
}